import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Spa(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M11.357 7.64c.222-.369.443-.703.643-.989.2.286.421.62.643.989C13.373 8.856 14 10.284 14 11.5c0 .036.002.07.005.105a12.091 12.091 0 00-2.029 2.52 12.723 12.723 0 00-1.995-2.428c.012-.064.019-.13.019-.197 0-1.216.628-2.644 1.357-3.86zm-3.22 2.582c.274-1.346.92-2.635 1.506-3.611a19.17 19.17 0 011.18-1.742C11.12 4.465 11.463 4 12 4s.88.465 1.176.868l.093.126c.296.395.692.955 1.088 1.617.576.959 1.208 2.218 1.491 3.537 1.772-1.164 3.596-1.787 4.908-2.118A1 1 0 0122 9c0 1.924-.358 4.868-1.774 7.368C18.772 18.935 16.209 21 12 21c-.183 0-.363-.004-.54-.012a1.01 1.01 0 01-.426-.026c-3.64-.29-5.92-2.23-7.26-4.594C2.358 13.868 2 10.924 2 9a1 1 0 011.252-.968c1.206.315 3.054.962 4.884 2.19zm10.349 5.16c-1.101 1.944-2.942 3.503-6.125 3.612.089-.835.287-1.6.568-2.304 1.48-3.712 4.583-5.485 7.008-6.329-.143 1.568-.551 3.432-1.451 5.021zm-12.972 0c.945 1.668 2.435 3.053 4.85 3.48.088-.892.28-1.728.555-2.509-1.61-3.43-4.637-5.154-6.854-5.97.145 1.563.553 3.418 1.45 5z",
    clipRule: "evenodd"
  }));
}

export default Spa;